import { v4 as uuidv4 } from "uuid";
import { ReactElement } from "react";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import LoseCustomQuizStarNodePreview from "../../features/sequence/node_previews/LoseCustomQuizStarNodePreview";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";

export interface ILoseCustomQuizStar extends Interaction {}

export const loseCustomQuizStarInteraction = (): InteractionFactoryEntity => {
  const view: ReactElement = <></>;

  const create = (
    getKeys: (amount: number) => string[],
  ): ILoseCustomQuizStar => {
    return {
      id: uuidv4(),
      name: "Lose Custom Quiz Star",
      type: InteractionType.LoseCustomQuizStar,
      properties: [],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): ILoseCustomQuizStar => {
    return interaction as ILoseCustomQuizStar;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void,
  ): ILoseCustomQuizStar => {
    return create(getKeys);
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    currentTake: Take,
    actorPresets: Actor[],
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const validateErrors = (): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
    getValue: (key: string) => string,
  ): SearchResultData[] => {
    const searchableStrings: string[] = [interaction.name];

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType,
    );
  };

  const filterType: string = "Lose Custom Quiz Star";

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <LoseCustomQuizStarNodePreview
        nodeId={nodeId}
        interaction={interaction}
      />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
